'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SelectedSite(site, selected) {
  this.ke = null;
  this.u0 = false;
  this.ke = site;
  this.u0 = selected;
}
export { $c_Lpresto_types$SelectedSite as $c_Lpresto_types$SelectedSite };
$p = $c_Lpresto_types$SelectedSite.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SelectedSite;
/** @constructor */
function $h_Lpresto_types$SelectedSite() {
}
export { $h_Lpresto_types$SelectedSite as $h_Lpresto_types$SelectedSite };
$h_Lpresto_types$SelectedSite.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("SelectedSite"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.ke));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.u0 ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SelectedSite)) {
    if ((this.u0 === x$0.u0)) {
      var x = this.ke;
      var x$2 = x$0.ke;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "SelectedSite";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.ke;
  }
  if ((n === 1)) {
    return this.u0;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.jW = (function() {
  return this.ke.e1;
});
$p.csX = (function() {
  return this.ke;
});
function $isArrayOf_Lpresto_types$SelectedSite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kc)));
}
export { $isArrayOf_Lpresto_types$SelectedSite as $isArrayOf_Lpresto_types$SelectedSite };
var $d_Lpresto_types$SelectedSite = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SelectedSite, "presto.types$SelectedSite", ({
  kc: 1,
  aH: 1,
  ka: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SelectedSite as $d_Lpresto_types$SelectedSite };
//# sourceMappingURL=presto.types$-Selected-Site.js.map
